import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';

@Injectable()
export class AlterarKmRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverUrl, ApiResources.VEICULOS);
  }
}
